import React, {
  Component
} from 'react';
import {
  Link
} from 'react-router';
import {
  connect
} from 'react-redux';
import {
  bindActionCreators
} from 'redux';
import {
  changeColor,
  clearDraw
} from '../../actions/ts_overlay_actions.js';
import {updateModal} from '../../actions/modal.js';
import {updateCanvas} from '../../actions/ts_canvas_actions.js';
import {deleteStrat} from '../../actions/ts_userData_actions.js';
import {setActive} from '../../actions/ts_active_actions.js';
import Promo from '../promo/';

class StratDelete extends Component {

  delete(userId, stratId){
      event.preventDefault();
       this.props.deleteStrat(userId, stratId).then((data) => {
           if (data.payload.errorCode) {
               this.setState({ message: data.payload.errorMessage });
           } else {
               /*this.setState({
                   message: 'Updated successfuly!',
               });*/
               this.props.setActive(null,null);
               this.props.updateModal(false,null);
           }
     }
   );
   }

  render() {
    var {currentUser} = this.props;
    var stratId = null;
    var stratName = '';
    if (this.props.strat != undefined) {
      stratName = this.props.strat.name;
    }
    if (this.props.id != undefined) {
      stratId = this.props.id;
    }
    return (
      <div>
        <form id="frmLogin" role="form" onSubmit={this.onFormSubmit}>
          <div className="form-group">
          <Promo/>
          <br/><br/>
          <label className="titleText" htmlFor="txtEmail">Are you sure you want to remove <b>{stratName}</b> from your playbook?</label>
          </div>
          <button type="button" className="buttonStyle" onClick={(event) => {this.delete(currentUser.uid,stratId);}}>Remove from Playbook</button>
          <div className="form-group">
          </div>
        </form>
      </div>
    );
}

}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({ updateModal, deleteStrat, setActive }, dispatch);
}


function mapStateToProps(state) {
    return { currentUser: state.currentUser};
}


export default connect(mapStateToProps, mapDispatchToProps)(StratDelete);



// WEBPACK FOOTER //
// ./src/app/components/stratDelete/index.jsx